import { LoadScript } from "@react-google-maps/api";
import {
  AutoComplete,
  Breadcrumb,
  Col,
  Collapse,
  Form,
  Input,
  Row,
  Spin,
  Select,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import "../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../utils/Notifications";
// import CompanyDepoAddress from "./CompanyDepoAddress";
import { authUserData } from "../../utils/Helper";
import CompanyDepoAddress from "../Package Master/CompanyDepoAddress";

// const { Option } = Select;

const MyCompany = () => {
  const { t } = useTranslation();
  const libraries = ["places"];
  const { Option } = Select;
  const formRef = useRef();
  const [form] = Form.useForm();
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const [options, setOptions] = useState([]);
  const { Panel } = Collapse;

  const initialState = {
    company_name: "",
    company_type: "",
    company_email: "",
    company_contact_name: "",
    company_number: "",
    company_abn_no: "",
    credit_limit: "",
    invoice_payment_interval: "",
    company_note: "",
    company_street_address: "",
    company_suburb: null,
    company_state: null,
    company_postcode: null,
    company_additional_detail: null,
    depo_address: [
      {
        depo_street_address: null,
        depo_suburb: null,
        depo_state: null,
        depo_postcode: null,
        depo_additional_details: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  // const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  // const handleCheckboxChange = (e) => {
  //   setChecked(e.target.checked);
  //   setState((prevState) => ({
  //     ...prevState,
  //     term_condition_accept: e.target.checked,
  //   }));
  // };

  //  const urls = state?.driving_license;
  // const urlone = state.document_url;

  // let filenamelicense = "";
  // // let filenameadhar = "";
  // try {
  //   if (fileLink) {
  //     filenamelicense = urls.split("/").pop();
  //   }
  // } catch (e) {
  //   filenamelicense = "";
  // }

  // const url = state?.police_check;

  // let filenamepolice_check = "";
  // try {
  //   if (fileLinkpolice_check) {
  //     filenamepolice_check = url.split("/").pop();
  //   }
  // } catch (e) {
  //   filenamepolice_check = "";
  // }
  const setWeightSizeFieldValue = (data) => {
    const fieldObject = {};
    data.forEach((address, index) => {
      fieldObject[`depo_street_address${index}`] = address.depo_street_address;
      fieldObject[`depo_suburb${index}`] = address.depo_suburb;
      fieldObject[`state${index}`] = address.state;
      fieldObject[`postcode${index}`] = address.postcode;
      fieldObject[`additional_details${index}`] = String(
        address.additional_details
      );
    });

    formRef.current.setFieldsValue(fieldObject); // Set form values
  };

  useEffect(() => {
    const companyGetById = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(`company/${CompanyId}/`);

        if (apiResponse?.data?.success) {
          const companyData = apiResponse.data.data;
          // Set state with initial values
          const depoAddresses =
            companyData.depo_address?.map((e) => ({
              depo_street_address: e?.depo_street_address,
              depo_suburb: e?.depo_suburb,
              depo_state: e?.depo_state,
              depo_postcode: e?.depo_postcode,
              depo_additional_details: e?.depo_additional_details,
            })) || [];
          setState({
            ...apiResponse?.data?.data,
            company_name: apiResponse?.data?.data?.company_name,
            company_type: apiResponse?.data?.data?.company_type,
            company_email: apiResponse?.data?.data?.company_email,
            company_number: String(apiResponse?.data?.data?.company_number),
            company_contact_name: apiResponse?.data?.data?.company_contact_name,
            company_abn_no: apiResponse?.data?.data?.company_abn_no,
            credit_limit: apiResponse?.data?.data?.credit_limit,
            invoice_payment_interval:
              apiResponse?.data?.data?.invoice_payment_interval,
            company_note: apiResponse?.data?.data?.company_note,
            company_street_address:
              apiResponse?.data?.data?.company_street_address,
            company_suburb: apiResponse?.data?.data?.company_suburb,
            company_state: apiResponse?.data?.data?.company_state,
            company_postcode: apiResponse?.data?.data?.company_postcode,
            company_additional_detail:
              apiResponse?.data?.data?.company_additional_detail,
            // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
            //   street_address: e?.street_address,
            //   suburb: e?.suburb,
            //   state: e?.state,
            //   postcode: e?.postcode,
            //   additional_details: e?.additional_details,
            // })),
            depo_address: depoAddresses,
          });

          formRef.current.setFieldsValue({
            ...apiResponse?.data?.data,
            company_name: apiResponse?.data?.data?.company_name,
            company_type: apiResponse?.data?.data?.company_type,
            company_email: apiResponse?.data?.data?.company_email,
            company_number: String(apiResponse?.data?.data?.company_number),
            company_contact_name: apiResponse?.data?.data?.company_contact_name,
            company_abn_no: apiResponse?.data?.data?.company_abn_no,
            credit_limit: apiResponse?.data?.data?.credit_limit,
            invoice_payment_interval:
              apiResponse?.data?.data?.invoice_payment_interval,
            company_note: apiResponse?.data?.data?.company_note,
            // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
            //   street_address: e?.street_address,
            //   suburb: e?.suburb,
            //   state: e?.state,
            //   postcode: e?.postcode,
            //   additional_details: e?.additional_details,
            // })),
            // depo_address: apiResponse?.data?.data?.depo_address?.map((e, index) => ({
            //   [`street_address${index}`]: e?.street_address,
            //   [`suburb_${0}`]: e?.suburb,
            //   [`state_${0}`]: e?.state,
            //   [`postcode_${0}`]: e?.postcode,
            //   [`additional_details_${0}`]: e?.additional_details,
            // })),
          });

          formRef.current.setFieldsValue({
            ...companyData,
            company_number: String(companyData.company_number),
            depo_address: depoAddresses,
          });

          setWeightSizeFieldValue(depoAddresses);
          setapiloading(false);
        }
      } catch (error) {
        setapiloading(false);
      }
    };
    if (CompanyId !== null) {
      companyGetById();
    }
  }, [CompanyId, t, reload]);

  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setState((prevstate) => ({
            ...prevstate,
            company_street_address: place.formatted_address,
            company_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            company_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            company_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          }));
          form.setFieldsValue({
            company_street_address: place.formatted_address,
            company_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            company_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            company_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          });
        }
      });
    }
  };
  const handleCompanyType = (value) => {
    setState({ ...state, company_type: value });
  };

  const handleSearch = useCallback(
    debounce((value) => {
      // setLoading(true);

      const service = new window.google.maps.places.AutocompleteService();

      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
            setLoading(false);
          } else {
            setOptions([]);
            setLoading(false);
          }
        });
      } else {
        setOptions([]);
        setLoading(false);
        setState((prevstate) => ({
          ...prevstate,
          company_street_address: "",
          company_suburb: "",
          company_state: "",
          company_postcode: "",
        }));
        form.setFieldsValue({
          company_street_address: "",
          company_suburb: "",
          company_state: "",
          company_postcode: "",
        });
      }
    }, 300),
    []
  );

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    // setState({ ...state, [name]: value });
    setState({ ...state, [name]: value.toLowerCase() });
  };
  const handleKeyPress = (e) => {
    // Allow only lowercase letters, numbers, and specific symbols
    const allowedChars = /^[a-z0-9@._-]*$/; // Add other allowed characters as needed
    if (!allowedChars.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
    }
  };

  const phoneValidLength = state.number;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 8) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }

    return Promise.resolve();
  };

  const handleSubmit = async () => {
    const payload = {
      // employe_id: state.employe_id,
      company_name: state.company_name,
      company_type: state.company_type,
      company_street_address: state.company_street_address,
      company_suburb: state.company_suburb,
      company_state: state.company_state,
      company_postcode: state.company_postcode,
      company_additional_detail: state.company_additional_detail,
      // address: "201 Sussex Street, Sydney NSW 2000",
      company_contact_name: state.company_contact_name,
      company_number: state.company_number,
      company_abn_no: state.company_abn_no,
      credit_limit: state.credit_limit,
      invoice_payment_interval: state.invoice_payment_interval,
      company_email: state.company_email,
      company_note: state.company_note,
      depo_address:
        state.depo_address &&
        state.depo_address.every(
          (person) =>
            person.depo_street_address === null &&
            person.depo_suburb === null &&
            person.depo_state === null &&
            person.depo_postcode === null &&
            person.depo_additional_details === null
        )
          ? []
          : state.depo_address,
    };
    try {
      setBtnLoading(true);
      let response;

      if (CompanyId === null) {
        response = await postRequest("company/", payload);
      } else {
        response = await patchRequest(`company/${CompanyId}/`, payload);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          CompanyId === null
            ? t("company_added_successfully")
            : t("company_updated_successfully")
        );
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        setReload(!reload);

        // navigate("/company-onboarding");
      }
    } catch (error) {
      // if (CompanyId === null) {
      //   ErrorNotificationMsg(
      //     t("error_in_adding_company")
      //   );
      // }
      // if (CompanyId !== null && !error?.message) {
      //   ErrorNotificationMsg(
      //     t("error_in_updating_company")
      //   );
      // }
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {CompanyId ? <h3>My Company</h3> : <h3>Add Company</h3>}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                {CompanyId ? "My Company" : "Add Company"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Form ref={formRef} form={form}>
            <LoadScript
              googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              libraries={libraries}
            >
              <Spin spinning={apiLoading}>
                {/* <Form autoComplete="off" form={form} > */}

                <Collapse defaultActiveKey={["1"]}>
                  <Panel header="1. Company Basic Details" key="1">
                    <Row gutter={[10]}>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <InputField
                          name="company_name"
                          label={t("company_name")}
                          placeholder={t("pl_client_name")}
                          rules={t("val_name")}
                          value={state?.company_name}
                          // pattern={"^[a-zA-Z ]+$"}
                          pattern={"^[a-zA-Z0-9\\s]+$"}
                          // prefix={<Name />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_type"
                          label={t("label_company_type")}
                          value={state.company_type}
                          rules={[
                            {
                              required: false,
                              message: <Trans>{t("val_company_type")}</Trans>,
                            },
                          ]}
                        >
                          <Select
                            showArrow
                            placeholder={t("pl_company_type")}
                            onChange={(value) => handleCompanyType(value)}
                            disabled
                          >
                            <Option key="1" value="Pre Paid">
                              Prepaid
                            </Option>
                            <Option key="2" value="Post Paid">
                              Postpaid
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <EmailField
                          name="company_email"
                          label={t("label_email")}
                          disabled
                          placeholder={t("pl_company_email_2")}
                          rules={t("val_email")}
                          value={state?.company_email}
                          // prefix={<Email />}
                          handleInputChange={handleInputChangeEmail}
                          onKeyPress={handleKeyPress}
                        />
                      </Col>
                      {/* <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="address"
                    label={t("pl_address")}
                    placeholder={t("pl_address_2")}
                    rules={t("val_address_2")}
                    value={state?.address}
                    prefix={<Company />}
                    handleInputChange={handleInputChange}
                    max={100}
                  />
                </Col> */}
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <InputField
                          name="company_contact_name"
                          label={t("label_contact_name")}
                          placeholder={t("pl_contact_name")}
                          rules={t("val_enter_contact_name")}
                          value={state.company_contact_name}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_number"
                          label={t("label_company_number")}
                          placeholder={t("pl_company_contact")}
                          rules={[
                            {
                              required: true,
                              validator: validatePhoneNumber,
                              message: (
                                <Trans> {t("val_company_contact")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <PhoneInput
                            // country={"in"}
                            disabled
                            country={"au"}
                            className="PhoneSection"
                            value={state?.company_number}
                            onChange={(company_number) =>
                              setState({
                                ...state,
                                company_number: company_number,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <InputField
                          name="company_abn_no"
                          label={t("label_abn_no")}
                          placeholder={t("pl_abn_no")}
                          rules={t("val_abn_no_2")}
                          //nonRequiredRules={t("val_abn_no_2")}
                          pattern={"^\\d{11}$"}
                          value={state.company_abn_no}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <InputField
                          name="invoice_payment_interval"
                          label={t("label_invoice_payment_interval")}
                          placeholder={t("pl_invoice_payment_interval")}
                          // rules={t("val_invoice_payment_interval")}
                          //nonRequiredRules={t("val_abn_no_2")}
                          pattern={"^\\d+$"}
                          value={state.invoice_payment_interval}
                          disabled
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={5}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <InputField
                          name="credit_limit"
                          label={t("label_credit_limit")}
                          placeholder={t("pl_credit_limit")}
                          // rules={t("val_credit_limit")}
                          //nonRequiredRules={t("val_abn_no_2")}
                          pattern={"^\\d+(\\.\\d+)?$"}
                          value={state.credit_limit}
                          // prefix={<Company />}
                          disabled
                          handleInputChange={handleInputChange}
                          max={10}
                        />
                      </Col>

                      {/* <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="depo_address"
                    label={t("label_depo_address")}
                    placeholder={t("pl_depo_address")}
                    // rules={t("val_depo_address_2")}
                    nonRequiredRules={t("val_depo_address_2")}
                    pattern={"^\\d{8,9}$"} // Pattern for 8 or 9 digits
                    value={state.depo_address}
                    prefix={<Company />}
                    handleInputChange={handleInputChange}
                    max={30}
                  />
                </Col> */}

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_street_address"
                          label={t("label_company_address")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: (
                          //       <Trans>
                          //         {t("search_company_address")}
                          //       </Trans>
                          //     ),
                          //   },
                          // ]}
                        >
                          <AutoComplete
                            id="company_street_address"
                            placeholder={t("search_company_address")}
                            options={options}
                            onSearch={handleSearch}
                            onSelect={handleSelect}
                            value={state.company_street_address}
                            onChange={(value) => {
                              setState((prevstate) => ({
                                ...prevstate,
                                company_street_address: value,
                              }));
                              form?.setFieldsValue({
                                company_street_address: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_additional_detail"
                          label={t("additional_details")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: (
                          //       <Trans>
                          //         {t("pl_enter_additional_detail")}
                          //       </Trans>
                          //     ),
                          //   },
                          // ]}
                        >
                          <Input
                            placeholder={t("enter_additional_details")}
                            name="company_additional_detail"
                            value={state.company_additional_detail}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                company_additional_detail: value,
                              }));
                              form.setFieldsValue({
                                company_additional_detail: value,
                              });
                            }}
                            // Adjust the number of rows as needed
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_suburb"
                          label={t("pl_suburb")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: (
                          //       <Trans>{t("val_suburb")}</Trans>
                          //     ),
                          //   },
                          // ]}
                        >
                          <Input
                            placeholder={t("pl_enter_suburb")}
                            name="company_suburb"
                            value={state.company_suburb}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                company_suburb: value,
                              }));
                              form.setFieldsValue({
                                company_suburb: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_state"
                          label={t("pl_state")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: (
                          //       <Trans>{t("val_state")}</Trans>
                          //     ),
                          //   },
                          // ]}
                        >
                          <Input
                            placeholder={t("pl_enter_state")}
                            name="company_state"
                            value={state.company_state}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                company_state: value,
                              }));
                              form.setFieldsValue({
                                company_state: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="company_postcode"
                          label={t("pl_Postcode")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: (
                          //       <Trans>{t("val_Postcode")}</Trans>
                          //     ),
                          //   },
                          // ]}
                        >
                          <Input
                            placeholder={t("pl_enter_postcode")}
                            name="company_postcode"
                            value={state.company_postcode}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                company_postcode: value,
                              }));
                              form.setFieldsValue({
                                company_postcode: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <InputField
                          name="company_note"
                          label={t("label_note")}
                          placeholder={t("pl_note")}
                          // rules={t("val_note_2")}
                          // nonRequiredRules={t("val_note_2")}
                          //pattern={"^\\d{8,9}$"} // Pattern for 8 or 9 digits
                          value={state?.company_note}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                    </Row>
                  </Panel>
                </Collapse>
                {authUserData()?.permission.includes(
                  "company|view_depoaddress"
                ) && (
                  <Collapse defaultActiveKey={["1"]}>
                    <Panel header="2. Company Depo Address" key="2">
                      <CompanyDepoAddress
                        state={state}
                        form={form}
                        setState={setState}
                        formRef={formRef}
                        // companyId={CompanyId}
                      />
                    </Panel>
                  </Collapse>
                )}
                <div className="FormFooter">
                  {/* <ButtonField
                    className="CancelGradiantBtn"
                    type="primary"
                    htmlType="button"
                    size="medium"
                    label="Cancel"
                    onClick={() => navigate("/company-onboarding")}
                  /> */}
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="submit"
                    label="Save"
                    onClick={handleSubmit}
                    // disabled={!checked || btnLoading}
                    loading={btnLoading}
                  />
                </div>

                {/* </Form> */}
              </Spin>
            </LoadScript>
          </Form>
        </div>
      </section>
    </>
  );
};

export default MyCompany;
